import React from 'react';
import { IUserAuthCallbackProps } from './types';

export const UserAuthCallback: React.FC<IUserAuthCallbackProps> = ({
    onLoad
}) => {

	React.useEffect(() => {
		const urlParams = new URLSearchParams(window.location.search);
		const code = urlParams.get('code');
		if (!!code) {
			onLoad(code);
		}
	}, []);

	return null;
};
